<div class="tabs">
  <ul class="flex border-b">
    <li class="mr-1" *ngFor="let tab of tabs" (click)="selectTab(tab)">
      <a [class.bg-white]="activeTab === tab">{{ tab.title }}</a>
    </li>
  </ul>
  <ng-container *ngTemplateOutlet="activeTab.template"></ng-container>
</div>
